import { IPromise } from 'angular';
import { IPagedResult } from '../../tn.django/django-client.service/djangoClient';
import {
    IDjangoFontFamily,
    IFontFamilyModel,
    isIFontFamilyModel,
} from '../classes';
import { latinize } from '../functions/latinize';
import { FontFamilyRepository } from './FontFamilyRepository';
import { FontListParams } from './FontRepository';
import { FontStyleRepository } from './FontStyleRepository';
import { mapIDjangoFontStyleToIFontStyleModel } from './FontStyleService';
import { FoundryService } from './FoundryService';
import { FontPosture, mapDjangpoFontPostureToFontPosture } from '../constants';

export function mapIDjangoFontFamilyToIFontFamilyModel(
    djangoFamily: IDjangoFontFamily,
    foundryService: FoundryService,
    styleRepository: FontStyleRepository
): Promise<IFontFamilyModel> {
    // TODO: check and see if it s, thanks for the insurance
    const canonicalFoundryPromise = foundryService.getDjangoFoundryByDjangoId(
        djangoFamily.canonical
    );
    const defStylePromise = styleRepository
        .get(djangoFamily.default_style)
        .then((style) => mapIDjangoFontStyleToIFontStyleModel(style));
    const latin_name = latinize(djangoFamily.name);
    const foundries = djangoFamily.foundry.map(
        (id) => foundryService.djangoFoundriesIdxByDjanoId[id]
    );
    const posture: FontPosture[] = djangoFamily.posture.map((p) =>
        mapDjangpoFontPostureToFontPosture(p)
    );

    return Promise.all([canonicalFoundryPromise, defStylePromise]).then(
        ([canonical_foundry, def_style]) => {
            const srefParams = {
                familyName: djangoFamily.slug,
                foundryEESubdomain: canonical_foundry.ee_subdomain,
            };
            const getSrefParams = () => srefParams;
            const family: IFontFamilyModel = {
                ...djangoFamily,
                def_style,
                latin_name,
                getSrefParams,
                canonical_foundry,
                foundries,
                posture,
                srefParams,
            };
            return family;
        }
    );
}

export class FontFamilyService {
    static $inject = [
        'FontFamilyRepository',
        'foundryService',
        'FontStyleRepository',
    ];
    constructor(
        protected repository: FontFamilyRepository,
        protected foundryService: FoundryService,
        protected styleRepository: FontStyleRepository
    ) {}

    protected _map(family: IDjangoFontFamily): IPromise<IFontFamilyModel> {
        return mapIDjangoFontFamilyToIFontFamilyModel(
            family,
            this.foundryService,
            this.styleRepository
        );
    }

    public get(id: number): IPromise<IFontFamilyModel> {
        return this.repository
            .get(id)
            .then((djangoFamily) => this._map(djangoFamily));
    }

    public list(
        filters: FontListParams
    ): IPromise<IPagedResult<IFontFamilyModel>> {
        return this.repository.list(filters).then((response) => {
            return Promise.all(
                response.results.map((djangoFamily) =>
                    this._map(djangoFamily).catch((e) => {
                        // make errors undefined so we can filter them out before returning.
                        console.error('FontFamilyService.list()', e);
                        return undefined;
                    })
                )
            ).then((families) => {
                return {
                    ...response,
                    results: families.filter(isIFontFamilyModel),
                };
            });
        });
    }
}

export class FontFamilyPublicService extends FontFamilyService {
    static $inject = [
        'FontFamilyPublicRepository',
        'foundryService',
        'FontStylePublicRepository',
    ];
}
